export function honeyPage() {
    return {
        solanaAddress: '',
        addressError: '',
        isProcessing: false,
        isMinting: false,
        hasBee: false,
        connections: [],
        dancePatterns: [],
        honeyPots: [],
        
        // New monthly features
        countdown: { days: 0, hours: 0, minutes: 0, seconds: 0 },
        currentMonth: '',
        communityGoals: {
            potsCollected: 0,
            potsTarget: 10000,
            potsReward: 'Bonus 500 $HONEY for everyone!',
            connections: 0,
            connectionsTarget: 500,
            connectionsReward: 'Unlock special Bee Dance event'
        },
        liveStats: {
            totalDrops: 0,
            activeUsers: 0,
            potsCollected: 0,
            communityGoal: '0%'
        },
        seasonalTheme: {
            name: '',
            description: '',
            emoji: '🍯'
        },
        userProgress: [],
        beeSwarm: [],

        init() {
            // Check if user has a bee if they previously minted one
            if (localStorage.getItem('hasBee')) {
                this.hasBee = true;
            }
            
            // Load saved connections and patterns
            this.connections = JSON.parse(localStorage.getItem('honeyConnections') || '[]');
            this.dancePatterns = JSON.parse(localStorage.getItem('dancePatterns') || '[]');
            this.honeyPots = JSON.parse(localStorage.getItem('honeyPots') || '[]');
            this.userProgress = JSON.parse(localStorage.getItem('userProgress') || '[]');
            
            // Initialize monthly features
            this.setupMonthlyFeatures();
            this.setupSeasonalTheme();
            this.setupCountdown();
            this.generateCalendar();
            this.setupHoneycombProgress();
            this.setupBeeSwarm();
            
            // Setup AR event listeners
            this.setupARListeners();
            
            // Start countdown timer
            this.startCountdown();
            
            // Update live stats periodically
            this.updateLiveStats();
            setInterval(() => this.updateLiveStats(), 30000); // Update every 30 seconds
        },

        setupMonthlyFeatures() {
            const now = new Date();
            this.currentMonth = now.toLocaleString('default', { month: 'long', year: 'numeric' });
            
            // Calculate next drop date (last day of current month)
            const nextDrop = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            this.nextDropDate = nextDrop;
            
            // Update community goals based on current data
            this.communityGoals.potsCollected = this.honeyPots.length;
            this.communityGoals.connections = this.connections.length;
        },

        setupSeasonalTheme() {
            const month = new Date().getMonth();
            const themes = [
                { name: 'Winter Frost', description: 'Crystal clear honey drops', emoji: '❄️' },
                { name: 'Spring Blossoms', description: 'Fresh floral honey flow', emoji: '🌸' },
                { name: 'Summer Sun', description: 'Golden summer sweetness', emoji: '☀️' },
                { name: 'Autumn Harvest', description: 'Rich amber harvest', emoji: '🍂' }
            ];
            
            this.seasonalTheme = themes[Math.floor(month / 3)];
            
            // Apply seasonal CSS classes
            document.body.classList.add(`season-${Math.floor(month / 3)}`);
        },

        setupCountdown() {
            this.updateCountdown();
        },

        startCountdown() {
            setInterval(() => {
                this.updateCountdown();
            }, 1000);
        },

        updateCountdown() {
            const now = new Date();
            const timeLeft = this.nextDropDate - now;
            
            if (timeLeft <= 0) {
                // Drop day!
                this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
                this.triggerHoneyDrop();
                return;
            }
            
            this.countdown = {
                days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
                hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((timeLeft % (1000 * 60)) / 1000)
            };
        },

        generateCalendar() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth();
            
            // Get first day of month and number of days
            const firstDay = new Date(year, month, 1);
            const lastDay = new Date(year, month + 1, 0);
            const daysInMonth = lastDay.getDate();
            
            const calendarGrid = document.getElementById('calendar-grid');
            if (!calendarGrid) return;
            
            calendarGrid.innerHTML = '';
            
            // Add empty cells for days before the first day of the month
            for (let i = 0; i < firstDay.getDay(); i++) {
                const emptyCell = document.createElement('div');
                emptyCell.className = 'h--8';
                calendarGrid.appendChild(emptyCell);
            }
            
            // Add days of the month
            for (let day = 1; day <= daysInMonth; day++) {
                const dayCell = document.createElement('div');
                dayCell.className = 'h-8 flex items-center justify-center text-sm rounded';
                
                const isToday = day === now.getDate();
                const isDropDay = day === lastDay.getDate(); // Last day of month is drop day
                const isCommunityGoal = day % 7 === 0; // Every Sunday is community goal day
                
                if (isToday) {
                    dayCell.classList.add('bg-amber-500', 'text-white');
                } else if (isDropDay) {
                    dayCell.classList.add('bg-amber-500/30', 'text-amber-300', 'border', 'border-amber-500');
                } else if (isCommunityGoal) {
                    dayCell.classList.add('bg-green-500/20', 'text-green-300');
                } else {
                    dayCell.classList.add('text-amber-200', 'hover:bg-amber-800/30');
                }
                
                dayCell.textContent = day;
                calendarGrid.appendChild(dayCell);
            }
        },

        setupHoneycombProgress() {
            const honeycombGrid = document.querySelector('.honeycomb-grid');
            if (!honeycombGrid) return;
            
            honeycombGrid.innerHTML = '';
            
            // Create 7 honeycomb cells for weekly progress
            for (let i = 0; i < 7; i++) {
                const cell = document.createElement('div');
                cell.className = 'honeycomb-cell';
                
                // Check if this week's progress is complete
                const weekComplete = this.userProgress.some(progress => 
                    progress.week === i && progress.complete
                );
                
                if (weekComplete) {
                    cell.classList.add('filled');
                }
                
                honeycombGrid.appendChild(cell);
            }
        },

        setupBeeSwarm() {
            const swarmContainer = document.getElementById('bee-swarm');
            if (!swarmContainer) return;
            
            // Create 15 bees
            for (let i = 0; i < 15; i++) {
                const bee = document.createElement('div');
                bee.className = 'bee';
                bee.innerHTML = '🐝';
                bee.style.cssText = `
                    position: absolute;
                    font-size: 1.5rem;
                    animation: fly${Math.floor(Math.random() * 3) + 1} ${15 + Math.random() * 10}s linear infinite;
                    animation-delay: ${Math.random() * 20}s;
                    left: ${Math.random() * 100}%;
                    top: ${Math.random() * 100}%;
                    z-index: 0;
                `;
                swarmContainer.appendChild(bee);
            }
        },

        updateLiveStats() {
            // Simulate live data updates
            this.liveStats.totalDrops = Math.floor(Math.random() * 1000) + 500;
            this.liveStats.activeUsers = Math.floor(Math.random() * 500) + 100;
            this.liveStats.potsCollected = this.honeyPots.length;
            this.liveStats.communityGoal = `${Math.floor((this.communityGoals.potsCollected / this.communityGoals.potsTarget) * 100)}%`;
        },

        triggerHoneyDrop() {
            // Special effects and notifications for drop day
            this.showToast('🎉 Monthly Honey Drop is LIVE! Claim your pots now!', 'success');
            
            // Add celebration effects
            this.addCelebrationEffects();
            
            // Auto-claim for users with addresses
            if (this.solanaAddress && this.validateAddress(this.solanaAddress) === '') {
                setTimeout(() => {
                    this.requestHoneyDrop();
                }, 2000);
            }
        },

        addCelebrationEffects() {
            // Add confetti or other celebration effects
            const celebration = document.createElement('div');
            celebration.className = 'celebration-effects';
            celebration.innerHTML = '✨🎉🍯';
            document.body.appendChild(celebration);
            
            setTimeout(() => {
                celebration.remove();
            }, 5000);
        },

        setupARListeners() {
            window.addEventListener('arNetworkConnection', (e) => {
                this.handleNetworkConnection(e.detail);
            });
            
            window.addEventListener('arHoneyPotFound', (e) => {
                this.handleHoneyPotDiscovery(e.detail);
            });
            
            window.addEventListener('arDancePattern', (e) => {
                this.handleDancePattern(e.detail);
            });
        },

        async handleNetworkConnection(connectionData) {
            try {
                const response = await fetch('/api/process-honey-drop', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        type: 'connection',
                        data: connectionData,
                        address: this.solanaAddress
                    })
                });

                if (!response.ok) throw new Error('Failed to process connection');

                const result = await response.json();
                this.connections.push(connectionData);
                localStorage.setItem('honeyConnections', JSON.stringify(this.connections));
                
                // Update community goals
                this.communityGoals.connections++;
                
                this.showToast(`🐝 Connected! Earned ${result.reward} $HONEY`, 'success');
            } catch (error) {
                console.error('Connection error:', error);
                this.showToast(error.message, 'error');
            }
        },

        async handleHoneyPotDiscovery(potData) {
            try {
                const response = await fetch('/api/process-honey-drop', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        type: 'pot',
                        data: potData,
                        address: this.solanaAddress
                    })
                });

                if (!response.ok) throw new Error('Failed to process honey pot');

                const result = await response.json();
                this.honeyPots.push(potData);
                localStorage.setItem('honeyPots', JSON.stringify(this.honeyPots));
                
                // Update community goals
                this.communityGoals.potsCollected++;
                
                this.showToast(`🍯 Sweet find! Earned ${result.reward} $HONEY`, 'success');
            } catch (error) {
                console.error('Honey pot error:', error);
                this.showToast(error.message, 'error');
            }
        },

        async handleDancePattern(patternData) {
            try {
                const response = await fetch('/api/process-honey-drop', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        type: 'dance',
                        data: patternData,
                        address: this.solanaAddress
                    })
                });

                if (!response.ok) throw new Error('Failed to process dance pattern');

                const result = await response.json();
                this.dancePatterns.push(patternData);
                localStorage.setItem('dancePatterns', JSON.stringify(this.dancePatterns));
                
                this.showToast(`💃 Nice moves! Earned ${result.reward} $HONEY`, 'success');
            } catch (error) {
                console.error('Dance pattern error:', error);
                this.showToast(error.message, 'error');
            }
        },

        validateAddress(address) {
            // Basic Solana address validation
            if (!address) {
                return 'Please enter a Solana address';
            }
            if (!/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address)) {
                return 'Invalid Solana address format';
            }
            return '';
        },

        async requestHoneyDrop() {
            this.addressError = this.validateAddress(this.solanaAddress);
            if (this.addressError) return;

            this.isProcessing = true;

            try {
                // Check M3M3 LP status
                const lpResponse = await fetch('/api/check-m3m3-lp', {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                });
                
                const lpStatus = await lpResponse.json();
                if (!lpResponse.ok) throw new Error('Failed to check liquidity status');

                // Send honey drop with LP multiplier
                const response = await fetch('/api/send-honey-drop', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        address: this.solanaAddress,
                        lpMultiplier: lpStatus.multiplier
                    })
                });

                const result = await response.json();
                if (!response.ok) throw new Error(result.error || 'Failed to send honey drop');

                // Update user progress
                const currentWeek = Math.floor(new Date().getDate() / 7);
                this.userProgress.push({ week: currentWeek, complete: true });
                localStorage.setItem('userProgress', JSON.stringify(this.userProgress));
                
                // Update honeycomb progress
                this.setupHoneycombProgress();
                
                this.showToast(`🍯 ${result.amount} $HONEY sent to your wallet!`, 'success');
                this.solanaAddress = ''; // Clear the input
            } catch (error) {
                console.error('Error sending honey drop:', error);
                this.showToast(error.message, 'error');
            } finally {
                this.isProcessing = false;
            }
        },

        async mintBee() {
            if (this.hasBee) {
                this.showToast('You already have a bee!', 'info');
                return;
            }

            if (!this.solanaAddress) {
                this.showToast('Please enter your Solana address first', 'error');
                return;
            }

            this.isMinting = true;

            try {
                // Call backend to mint bee
                const response = await fetch('/api/mint-bee', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        walletAddress: this.solanaAddress
                    })
                });

                if (!response.ok) throw new Error('Failed to mint bee');

                const result = await response.json();
                
                // Update bee status
                this.hasBee = true;
                localStorage.setItem('hasBee', 'true');
                
                // Show success message with link
                this.showToast(`Bee minted successfully! View your bee at: cseas.fun/t/${result.tokenId}`, 'success');

                // Redirect to bee page
                window.location.href = `/t/${result.tokenId}`;
            } catch (error) {
                console.error('Error minting bee:', error);
                this.showToast('Error minting bee', 'error');
            } finally {
                this.isMinting = false;
            }
        },

        showToast(message, type = 'info') {
            const toast = document.createElement('div');
            toast.className = `alert alert-${type}`;
            toast.innerHTML = message;
            
            const container = document.getElementById('toast-container');
            container?.appendChild(toast);
            
            setTimeout(() => {
                toast.remove();
            }, 3000);
        }
    };
}
